 



<template>
  <div class="modal-card"  >
     <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
 
   
    <b-notification v-if="formLoadError" type="is-danger" :closable="false">
        {{ formLoadError }}
        <b-button @click="initializeForm" :loading="isFullScreenLoading">Retry</b-button>
     </b-notification>
    <header class="modal-card-head custom-modal-card-head" >
                    <nav class="level level-scroll">
						<div class="level-left">
							<div class="level-item">
                                <b-button   type="is-primary"
                                       icon-left="arrow-left" @click="close">
                                       Back
                                </b-button>  
							</div>
							<div class="level-item">

                                <b-button type="is-success"
                                     icon-left="cloud-upload"
                                      :disabled="!isFormReady || isFullScreenLoading" @click="save"
                                >Update</b-button>
                                <!-- <b-dropdown aria-role="list">
                                                  <template #trigger="{ active }">
                                                      <b-button
                                                          size="is-small"
                                                          label=""
                                                          type="is-ghost"
                                                          :icon-right="active ? 'dots-vertical' : 'dots-horizontal'" />
                                                  </template>


                                           
                                                
                                                  <b-dropdown-item aria-role="listitem" @click="isShowInfo= !isShowInfo"  >   {{ isShowInfo ? 'Hide Info' : 'Show Info' }} </b-dropdown-item> 
                                                  <hr>
                                                  <b-dropdown-item aria-role="listitem" :disabled="!isFormReady || isFullScreenLoading" @click="save"  ><span
                                                                                            :class="modeManuallyLabAutomate == 0 ? 'has-text-grey-darker' : 'has-text-danger' "
                                                                                            ><b-icon
                                                                                                    icon="cloud-upload"
                                                                                                    size="is-small"
                                                                                                    :type="modeManuallyLabAutomate == 0 ? 'is-success':  'is-danger' ">
                                                                                                </b-icon>
                                                                                                 {{modeManuallyLabAutomate == 0 ? 'Save' : 'Update' }}
                                                                                          </span> 
                                                  </b-dropdown-item> 
                                </b-dropdown> -->
							</div>
                            <div class="level-item " >
                                &nbsp;&nbsp;&nbsp;
                            </div>    
                            <div class="level-item " >
                                &nbsp;&nbsp;&nbsp;
                            </div>   
                            <div class="level-item " >
                                &nbsp;&nbsp;&nbsp;
                            </div> 
                            <div class="level-item">
								<b-radio-button v-model="activeTab"
                                                        :native-value="0"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 0 ? getIcon : ``"></b-icon>
                                                        <span>Hematology
                                                        </span>
                                </b-radio-button>
							</div>
                            <div class="level-item">
                                <b-radio-button v-model="activeTab"
                                                        :native-value="1"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 1 ? getIcon : ``"></b-icon>
                                                        <span>Blood Morphology</span>
                                </b-radio-button>
							</div>
                            <div class="level-item">
                                <b-radio-button v-model="activeTab"
                                                        :native-value="2"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 2 ? getIcon : ``"></b-icon>
                                                        <span>Blood Chemistry</span>
                                </b-radio-button>
							</div>
                            <div class="level-item">
                                <b-radio-button v-model="activeTab"
                                                        :native-value="3"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 3 ? getIcon : ``"></b-icon>
                                                        <span>Body Fluid</span> 
                                </b-radio-button>
							</div>
                            <div class="level-item">
                                <b-radio-button v-model="activeTab"
                                                        :native-value="4"
                                                        :type="modeManuallyLabAutomate == 0 ?  `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 4 ? getIcon : ``"></b-icon>
                                                        <span>Blood Gas</span> 
                                </b-radio-button>
							</div>
                            <div class="level-item">
                                <b-radio-button v-model="activeTab"
                                                        :native-value="5"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 5 ? getIcon : ``"></b-icon>
                                                        <span>Hormone</span> 
                                </b-radio-button>
							</div>
                            <div class="level-item">
                                <b-radio-button v-model="activeTab"
                                                        :native-value="6"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 6 ? getIcon : ``"></b-icon>
                                                        <span>Blood Parasite</span> 
                                </b-radio-button>
							</div>
                            <div class="level-item">
                                <b-radio-button v-model="activeTab"
                                                        :native-value="7"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 7 ? getIcon : ``"></b-icon>
                                                        <span>Urine Analysis</span> 
                                </b-radio-button>
							</div>
                            <div class="level-item">
                                <b-radio-button v-model="activeTab"
                                                        :native-value="8"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 8 ? getIcon : ``"></b-icon>
                                                        <span>Outlab</span> 
                                </b-radio-button>
							</div>
                            <div class="level-item">
                                <b-radio-button v-model="activeTab"
                                                        :native-value="9"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 9 ? getIcon : ``"></b-icon>
                                                        <span>Other</span> 
                                </b-radio-button>
                            </div>
						</div>
					</nav>

                  


                    <!-- <nav class="level is-mobile  ">
                                  <div class="level-left">
                                    <div class="level-item">
                                      <b-button   type="is-text"
                                       icon-left="arrow-left" @click="close">
                                      </b-button>   
                                    </div>  
                                    <div class="level-item">
                                                <b-dropdown aria-role="list">
                                                  <template #trigger="{ active }">
                                                      <b-button
                                                          size="is-small"
                                                          label=""
                                                          type="is-ghost"
                                                          :icon-right="active ? 'dots-vertical' : 'dots-horizontal'" />
                                                  </template>


                                           
                                                
                                                  <b-dropdown-item aria-role="listitem" @click="isShowInfo= !isShowInfo"  >   {{ isShowInfo ? 'Hide Info' : 'Show Info' }} </b-dropdown-item> 
                                                  <hr>
                                                  <b-dropdown-item aria-role="listitem" :disabled="!isFormReady || isFullScreenLoading" @click="save"  ><span
                                                                                            :class="modeManuallyLabAutomate == 0 ? 'has-text-grey-darker' : 'has-text-danger' "
                                                                                            ><b-icon
                                                                                                    icon="cloud-upload"
                                                                                                    size="is-small"
                                                                                                    :type="modeManuallyLabAutomate == 0 ? 'is-success':  'is-danger' ">
                                                                                                </b-icon>
                                                                                                 {{modeManuallyLabAutomate == 0 ? 'Save' : 'Update' }}
                                                                                          </span> 
                                                  </b-dropdown-item> 
                                              </b-dropdown>
                                                
                                    </div>
                                    <div class="level-item mr-5 is-size-6 has-text-grey">
                                        Lab No. <span class="has-text-grey-darker ml-2"> {{dataToEdit_ManuallyLabAutomate['info'].idlab}} </span>      
                                    </div>
                                  </div>
                                  <div class="level-right">
                                             <b-field>
                                                    <b-radio-button v-model="activeTab"
                                                        :native-value="0"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 0 ? getIcon : ``"></b-icon>
                                                        <span>Hematology
                                                        </span>
                                                    </b-radio-button>

                                                    <b-radio-button v-model="activeTab"
                                                        :native-value="1"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 1 ? getIcon : ``"></b-icon>
                                                        <span>Blood Morphology</span>
                                                    </b-radio-button>



                                                    <b-radio-button v-model="activeTab"
                                                        :native-value="2"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 2 ? getIcon : ``"></b-icon>
                                                        <span>Blood Chemistry</span>
                                                    </b-radio-button>

                                                    <b-radio-button v-model="activeTab"
                                                        :native-value="3"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 3 ? getIcon : ``"></b-icon>
                                                        <span>Body Fluid</span> 
                                                    </b-radio-button>

                                                    <b-radio-button v-model="activeTab"
                                                        :native-value="4"
                                                        :type="modeManuallyLabAutomate == 0 ?  `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 4 ? getIcon : ``"></b-icon>
                                                        <span>Blood Gas</span> 
                                                    </b-radio-button>

                                                    <b-radio-button v-model="activeTab"
                                                        :native-value="5"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 5 ? getIcon : ``"></b-icon>
                                                        <span>Hormone</span> 
                                                    </b-radio-button>
                                                    <b-radio-button v-model="activeTab"
                                                        :native-value="6"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 6 ? getIcon : ``"></b-icon>
                                                        <span>Blood Parasite</span> 
                                                    </b-radio-button>
                                                    <b-radio-button v-model="activeTab"
                                                        :native-value="7"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 7 ? getIcon : ``"></b-icon>
                                                        <span>Urine Analysis</span> 
                                                    </b-radio-button>

                                                    <b-radio-button v-model="activeTab"
                                                        :native-value="8"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 8 ? getIcon : ``"></b-icon>
                                                        <span>Outlab</span> 
                                                    </b-radio-button>

                                                    <b-radio-button v-model="activeTab"
                                                        :native-value="9"
                                                        :type="modeManuallyLabAutomate == 0 ? `is-info is-light is-outlined` : `is-danger is-light is-outlined` ">
                                                        <b-icon :icon="activeTab == 9 ? getIcon : ``"></b-icon>
                                                        <span>Other</span> 
                                                    </b-radio-button>

                                            </b-field>
                                  </div>
                    </nav>
 
              -->
             
                     

                          

     
    </header>
    <header class="modal-card-head custom-modal-card-head1" >
          <nav class="level is-mobile">
                                  <div class="level-left">
                                          <div class="level-item"  >
                                             <OPDInfo class="mt-5"  :dataToDisplay = "opdSelected"  style="padding-top:10px; " />   	 
                                          </div>
                                  </div>
                                  <div class="level-right">
                                  </div>
                                </nav>                
    </header>  





    <section class="modal-card-body" >

    <!-- {{dataToEdit_ManuallyLabAutomate['ua_v2']}}  -->
 

            <section v-if="showProgress">
                  <b-message type="is-info" class="is-size-3">
                      {{msgProgress}}
                  </b-message>  

                  <b-progress 
                      :rounded="false" 
                      :value="valueProgress" 
                      type="is-success" 
                      show-value
                      size="is-large"
                      format="percent"
                  ></b-progress>
            </section> 
              
             <section v-show="isShowInfo">
                                <nav class="level is-mobile">
                                  <div class="level-left">
                                          <!-- <div class="level-item">
                                                <b-button type="is-primary" size="is-small" class="mb-3" outlined  @click="changeOPD"> Change OPD</b-button>
                                          </div> -->
                                          <!-- <div class="level-item" v-if="modeManuallyLabAutomate==1 && labNoToEdit != '' ">
                                                <p  class="mb-3"> LAB No. : {{labNoToEdit}}</p>   
                                          </div>   -->
                                          <div class="level-item">
                                             <OPDInfo class="mt-5"  :dataToDisplay = "opdSelected"/>   	 
                                          </div>
                                  </div>
                                  <div class="level-right">
                                  </div>
                                </nav>




             </section> 
              
             <section v-show="activeTab == 0">
                <HematologyParam   />
             </section>
             <section v-show="activeTab == 1">
                <BlMor />
             </section>
             <section v-show="activeTab == 2"   >
                <BlChemParam  />
             </section>
             <section v-show="activeTab == 3">
                <BodyFluidParam  /> 
             </section>
             <section v-show="activeTab == 4">
                <BlGasParam  />
             </section>
             <section v-show="activeTab == 5">
               <HormoneParam  />
             </section>
             <section v-show="activeTab == 6">
               <BlParasiteParam  />
             </section>
             <section v-show="activeTab == 7">
               <UAParam />
             </section>
             <section  v-show="activeTab == 8">
               <OutLabParams />
             </section>
             <section v-show="activeTab == 9">
               <OtherParam />
             </section>

             <!-- <section v-show="activeTab == 10">
               <CBC_Images />
             </section> -->



    </section>

 

       <SearchOPD  
          :mode="modeSearchOPD"
          @closeWithChangeForManualLabAutomate="closeSearchOPDWithChange"  
          ref="SearchOPD"/>








<!-- test -->
 <!-- How can i responsive for all element under "b-menu" ?
 <nav class="level is-mobile">
                                  <div class="level-left">
                                   
                                  </div>
                                  <div class="level-right" id="b-menu">
                                             <b-field  >
                                                    <b-radio-button v-model="activeTab"
                                                        :native-value="0"
                                                        >
                                                         
                                                        <span> 1
                                                        </span>
                                                    </b-radio-button>
                                                    <b-radio-button v-model="activeTab"
                                                        :native-value="1"
                                                        >
                                                        <span>2
                                                        </span>
                                                    </b-radio-button>



                                             </b-field>
                                  </div>
                    </nav> -->






  </div>
</template>


<script>

 
import { mapState , mapMutations ,mapActions } from "vuex";
import {BLANK_OPD_FOR_MANUAL_LAB_AUTOMATE} from '@/utils.js'

import OPDInfo from '../../UtilsComponents/OPDInfo.vue'
import HematologyParam from './HematologyParam.vue'
import BlMor from './BlMor.vue'
import BlChemParam from './BlChemParam.vue'
import BodyFluidParam from './BodyFluidParam.vue'
import BlGasParam from './BlGasParam.vue' 
import HormoneParam from './HormoneParam.vue'
import BlParasiteParam from './BlParasiteParam.vue'
import UAParam from './UAParam.vue'
import OutLabParams from './OutLabParams.vue'
import OtherParam from './OtherParam.vue'
// import CBC_Images from './CBC_Images.vue'  

 
import SearchOPD from '../../SearchOPD.vue'
 

import axios from "axios";
import {getBaseURLforBackEnd,getConfigAxios}  from '@/utils.js'
 



export default {
    name : "ManuallyCreateLabAutomateV2",
 
    mounted(){
      //  console.log("Mount => ManuallyCreateLabAutomateV2")
       this.activeTab = 0
    },
    components:{
        OPDInfo, 
        HematologyParam,
        BlMor,
        BlChemParam,
        BodyFluidParam,
        BlGasParam ,
        HormoneParam,
        BlParasiteParam ,
        UAParam,
        OutLabParams,
        OtherParam,
        // CBC_Images,
        SearchOPD,
    },
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()
                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },  
    computed:{
            ...mapState({
                access_token : state => state.master_data.access_token,
                opdSelected : state => state.manually_create_lab_automate.opdSelected ,
              
                lab_HIS_LIS_Mapping: state => state.manually_create_lab_automate.lab_HIS_LIS_Mapping ,
                dataModelMNLABAutomate : state => state.manually_create_lab_automate.dataModelMNLABAutomate ,
                blParasiteParam: state => state.manually_create_lab_automate.blParasiteParam , 
                blParasiteMaterSelected: state => state.manually_create_lab_automate.blParasiteMaterSelected , 
                blParasiteDetailSelected: state => state.manually_create_lab_automate.blParasiteDetailSelected , 


                blMorSelected: state => state.manually_create_lab_automate.blMorSelected , 
                UAParams: state => state.manually_create_lab_automate.UAParams , 
                
                 


                modeManuallyLabAutomate: state => state.manually_create_lab_automate.modeManuallyLabAutomate ,  // 0 == new insert , 1 == edit mode

                // labNoToEdit : state => state.manually_create_lab_automate.labNoToEdit ,


                commentNote : state => state.manually_create_lab_automate.commentNote , 
                singni_phy: state => state.manually_create_lab_automate.singni_phy , 
                tentative_dx: state => state.manually_create_lab_automate.tentative_dx , 
                test_desire: state => state.manually_create_lab_automate.test_desire , 
                special_rq: state => state.manually_create_lab_automate.special_rq , 
                diagnosisNote: state => state.manually_create_lab_automate.diagnosisNote , 
                resultRemark: state => state.manually_create_lab_automate.resultRemark , 

                // arrDVM: state => state.manually_create_lab_automate.arrDVM , 
                // dvmSelected: state => state.manually_create_lab_automate.dvmSelected , 


                arrUsers: state => state.manually_create_lab_automate.arrUsers , 
                userSelected: state => state.manually_create_lab_automate.userSelected , 

                




                dataToEdit_ManuallyLabAutomate : state => state.manually_create_lab_automate.dataToEdit_ManuallyLabAutomate , 
                blMor: state => state.manually_create_lab_automate.blMor ,



                 
            }),
         
        // arrDVM_Model:{
        //         get: function () {
        //             return this.arrDVM
        //         },
        //         set: function (newValue) {
        //             this.setArrDVM(newValue)
        //         }
        // } ,
        arrUsers_Model:{
                get: function () {
                    return this.arrUsers
                },
                set: function (newValue) {
                    this.setUserSelected(newValue)
                }
        } ,

        commentNoteModel:{
                get: function () {
                    return this.commentNote
                },
                set: function (newValue) {
                    this.setCommentNote(newValue)
                }
        } ,
        singni_phyModel:{
                get: function () {
                    return this.singni_phy
                },
                set: function (newValue) {
                    this.setSingni_phy(newValue)
                }
        } ,
        tentative_dxModel:{
                get: function () {
                    return this.tentative_dx
                },
                set: function (newValue) {
                    this.setTentative_dx(newValue)
                }
        } ,
        test_desireModel:{
                get: function () {
                    return this.test_desire
                },
                set: function (newValue) {
                    this.setTest_desire(newValue)
                }
        } ,
        special_rqModel:{
                get: function () {
                    return this.special_rq
                },
                set: function (newValue) {
                    this.setSpecial_rq(newValue)
                }
        } ,
        diagnosisNoteModel:{
                get: function () {
                    return this.diagnosisNote
                },
                set: function (newValue) {
                    this.setDiagnosisNote(newValue)
                }
        } ,
        resultRemarkModel:{
                get: function () {
                    return this.resultRemark
                },
                set: function (newValue) {
                    this.setResultRemark(newValue)
                }
        } ,




        getIcon(){
          return this.modeManuallyLabAutomate == 0 ? `plus-box` : `pencil-circle`
        },

    },
    props:{
        isComponentModalActive : Boolean,
        dataToEdit: Object,
        mode : Number, // 0 == new , 1 == edit
    },
    methods:{
        ...mapActions({
            fetchLab_his_lis_mapping: 'manually_create_lab_automate/fetchLab_his_lis_mapping' ,
            fetchBlMor: 'manually_create_lab_automate/fetchBlMor' ,
            fetchBlParasite: 'manually_create_lab_automate/fetchBlParasite' ,
            fetchUAParams: 'manually_create_lab_automate/fetchUAParams' ,
            // fetchArrDVM: 'manually_create_lab_automate/fetchArrDVM' ,

            fetchArrUsers: 'manually_create_lab_automate/fetchArrUsers' ,
        }),
        ...mapMutations({
            setCommentNote : 'manually_create_lab_automate/setCommentNote' ,
            setSingni_phy : 'manually_create_lab_automate/setSingni_phy' ,
            setTentative_dx: 'manually_create_lab_automate/setTentative_dx' ,
            setTest_desire: 'manually_create_lab_automate/setTest_desire' ,
            setSpecial_rq: 'manually_create_lab_automate/setSpecial_rq' ,


            setDiagnosisNote: 'manually_create_lab_automate/setDiagnosisNote' ,
            setResultRemark: 'manually_create_lab_automate/setResultRemark' ,
            

            setOpdSelected : 'manually_create_lab_automate/setOpdSelected' ,
            setDataModelMNLABAutomate: 'manually_create_lab_automate/setDataModelMNLABAutomate' ,
            // setArrDVM: 'manually_create_lab_automate/setArrDVM' ,
            // setDVMSelected: 'manually_create_lab_automate/setDVMSelected' ,
            setArrUsers: 'manually_create_lab_automate/setArrUsers' ,
            setUserSelected: 'manually_create_lab_automate/setUserSelected' ,

            // set_dvmAutocomplete: 'manually_create_lab_automate/set_dvmAutocomplete' ,
            set_userAutocomplete: 'manually_create_lab_automate/set_userAutocomplete' ,



            // images
            setCBCImages: 'manually_create_lab_automate/setCBCImages' ,

            // bl parasite
            setBlParasiteMaterSelected : 'manually_create_lab_automate/setBlParasiteMaterSelected' ,
            setBlParasiteDetailSelected: 'manually_create_lab_automate/setBlParasiteDetailSelected' ,

        }),

        filterOnlyPosVal(_type){

          if(_type=='cast'){
            return this.UAParams.cast_pos_mst.filter(dat => dat.val !== "");
          }
          else if(_type=='cystal'){
            return this.UAParams.cystal_pos_mst.filter(dat => dat.val !== "");
          }
          else if(_type=='epith'){
            return this.UAParams.epith_pos_mst.filter(dat => dat.val !== "");
          }

          return []
          
        }, 
        async initializeForm() {
            if (this.isFullScreenLoading) return
            this.isFormReady = false
            this.formLoadError = ''
            this.isFullScreenLoading = true
            this.showProgress = true
            this.valueProgress = 0
            try {
                await this.reloadBlankTemplate()
                await this.fillOldData()
                this.isFormReady = true
            } catch (error) {
                this.formLoadError = 'Unable to load form data or user list. Please retry.'
            } finally {
                this.showProgress = false
                this.isFullScreenLoading = false
            }
        },
        save(){
            if (!this.isFormReady || this.isFullScreenLoading) return

           //  console.log(JSON.stringify( this.UAParams ))
           //  clean data of payload UAParams before save 
           //  const UA_Tmp =  JSON.parse(JSON.stringify(this.UAParams)) // Object.assign({},this.UAParams )
           //  delete UA_Tmp.colection_tech_mst
           //  delete UA_Tmp.colection_tech_val
           //  delete UA_Tmp.color_mst
           //  delete UA_Tmp.color_val
           //  delete UA_Tmp.trans_mst
           //  delete UA_Tmp.trans_val
           //  delete UA_Tmp.rbc_mst
           //  delete UA_Tmp.wbc_mst

          if(!this.opdSelected.idopd){

                 this.isShowInfo = true
                 this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `OPD No. <br/>
                                      is null , please check!!!`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle-outline',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                           })
                 return          
          }

           //
           if (  ! this.dataToEdit_ManuallyLabAutomate['info'].idlab  ){
                            this.$buefy.dialog.alert({
                            title: 'Error',
                            message: ` some problem with lab no. , please try again! `,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle-outline',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                           })
                          return   
          }




          const UA_Tmp ={
            "ur_creatinine" :    this.UAParams.ur_creatinine ? this.UAParams.ur_creatinine  : null ,
            "ur_creatinine_remark" :    this.UAParams.ur_creatinine_remark ? this.UAParams.ur_creatinine_remark  : null ,

            "ur_protein" :    this.UAParams.ur_protein ? this.UAParams.ur_protein  : null ,
            "ur_protein_remark" :    this.UAParams.ur_protein_remark ? this.UAParams.ur_protein_remark  : null ,

            "ur_cortisol" :    this.UAParams.ur_cortisol ? this.UAParams.ur_cortisol  : null ,
            "ur_cortisol_remark" :    this.UAParams.ur_cortisol_remark ? this.UAParams.ur_cortisol_remark  : null ,


            "ur_ph" :    this.UAParams.ur_ph  ? this.UAParams.ur_ph  : null ,
            "ur_sp_gr" :    this.UAParams.ur_sp_gr  ? this.UAParams.ur_sp_gr  : null ,
            "uccr" :    this.UAParams.uccr  ? this.UAParams.uccr  : null ,
            "uccr_remark" :    this.UAParams.uccr_remark  ? this.UAParams.uccr_remark  : null ,
            "upcr" :    this.UAParams.upcr  ? this.UAParams.upcr  : null ,
            "upcr_remark" :    this.UAParams.upcr_remark  ? this.UAParams.upcr_remark  : null ,

            "colection_tech" : this.UAParams.colection_tech_id ? this.UAParams.colection_tech_id : null,
            "color"  :    this.UAParams.color_id   ? this.UAParams.color_id : null ,
            "trans"  :    this.UAParams.trans_id   ? this.UAParams.trans_id : null ,
            "rbc"    :    this.UAParams.rbc        ? this.UAParams.rbc : null ,
            "wbc"    :    this.UAParams.wbc        ? this.UAParams.wbc : null ,
            "nirite"  :   this.UAParams.nirite     ? this.UAParams.nirite : null ,
            "nirite_pos"   : this.UAParams.nirite && this.UAParams.nirite ==2  ? this.UAParams.nirite_pos  : null ,
            "urobilinogen" :   this.UAParams.urobilinogen     ? this.UAParams.urobilinogen : null ,
            "urobilinogen_pos" : this.UAParams.urobilinogen && this.UAParams.urobilinogen ==2  ? this.UAParams.urobilinogen_pos  : null ,
            "protein"     :  this.UAParams.protein     ? this.UAParams.protein : null ,
            "protein_pos" :  this.UAParams.protein && this.UAParams.protein ==2  ? this.UAParams.protein_pos  : null ,
            "blood"       :  this.UAParams.blood     ? this.UAParams.blood : null ,
            "blood_pos"   :  this.UAParams.blood && this.UAParams.blood ==2  ? this.UAParams.blood_pos  : null ,
            "ketone"      :  this.UAParams.ketone     ? this.UAParams.ketone : null ,
            "ketone_pos"  :  this.UAParams.ketone && this.UAParams.ketone ==2  ? this.UAParams.ketone_pos  : null , 
            "bilirubin"   :  this.UAParams.bilirubin     ? this.UAParams.bilirubin : null ,
            "bilirubin_pos" :this.UAParams.bilirubin && this.UAParams.bilirubin ==2  ? this.UAParams.bilirubin_pos  : null , 
            "glucose"     :  this.UAParams.glucose     ? this.UAParams.glucose : null ,
            "glucose_pos" :  this.UAParams.glucose && this.UAParams.glucose ==2  ? this.UAParams.glucose_pos  : null ,   
            "fat_drp"     :  this.UAParams.fat_drp     ? this.UAParams.fat_drp : null ,
            "fat_drp_pos" :  this.UAParams.fat_drp && this.UAParams.fat_drp ==2  ? this.UAParams.fat_drp_pos  : null , 
            "bact"        :  this.UAParams.bact     ? this.UAParams.bact : null ,
            "bact_pos"    :  this.UAParams.bact && this.UAParams.bact ==2  ? this.UAParams.bact_pos  : null , 
            "leu"         :  this.UAParams.leu     ? this.UAParams.leu : null ,
            "leu_pos"     :  this.UAParams.leu && this.UAParams.leu ==2  ? this.UAParams.leu_pos  : null , 
            "sprem"       :  this.UAParams.sprem     ? this.UAParams.sprem : null ,
            "sprem_pos"   :  this.UAParams.sprem && this.UAParams.sprem ==2  ? this.UAParams.sprem_pos  : null ,
            
            
            "fungi"       :  this.UAParams.fungi     ? this.UAParams.fungi : null ,
            "fungi_pos"   :  this.UAParams.fungi && this.UAParams.fungi ==2  ? this.UAParams.fungi_pos  : null ,

            "yeast"       :  this.UAParams.yeast     ? this.UAParams.yeast : null ,
            "yeast_pos"   :  this.UAParams.yeast && this.UAParams.yeast ==2  ? this.UAParams.yeast_pos  : null ,


            "cast" : this.UAParams.cast_np     ? this.UAParams.cast_np : null ,       
            "cast_pos": (this.UAParams.cast_np && this.UAParams.cast_np === 2)
                                                                              ?  this.filterOnlyPosVal('cast')
                                                                              : [],
            "cystal" : this.UAParams.cystal_np     ? this.UAParams.cystal_np : null ,       
            "cystal_pos": (this.UAParams.cystal_np && this.UAParams.cystal_np === 2)
                                                                              ?  this.filterOnlyPosVal('cystal')
                                                                              : [],        
            "epith" : this.UAParams.epith_np     ? this.UAParams.epith_np : null ,       
            "epith_pos": (this.UAParams.epith_np && this.UAParams.epith_np === 2)
                                                                              ?  this.filterOnlyPosVal('epith')
                                                                              : [],   
                                                                                                                                                                                                             
          } 
          
          // test check if UA_Tmp cast , cystal and epith == 2 and cast_pos , cystal_pos ,epith_pos is empty array?
          if (    this.UAParams.cast_np && this.UAParams.cast_np === 2  && this.filterOnlyPosVal('cast').length==0 ){
                            this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `There is an error in the cast  positive, <br/>
                                      You must selection of some positive value.  `,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle-outline',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                           })
                          return   
          }

           if (  this.UAParams.cystal_np && this.UAParams.cystal_np === 2 && this.filterOnlyPosVal('cystal').length==0    ){
                            this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `There is an error in the crystal  positive, <br/>
                                      You must selection of some positive value.  `,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle-outline',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                           })
                          return   
          }


           if (   this.UAParams.epith_np && this.UAParams.epith_np === 2  && this.filterOnlyPosVal('epith').length==0   ){
                            this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `There is an error in the epith positive, <br/>
                                      You must selection of some positive value.  `,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle-outline',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                           })
                          return   
          }



           
        

          //  console.log(JSON.stringify( this.UAParams.rbc ))
          // console.log(JSON.stringify( UA_Tmp ))

          // bl parasite
          const tmpRes_statusBlparasite = this.blParasiteMaterSelected =='' || this.blParasiteMaterSelected == null ?  null : this.blParasiteMaterSelected
        //   console.log(`blParasiteMaterSelected --> ${this.blParasiteMaterSelected}`)
        //   console.log(`tmpRes_statusBlparasite --> ${tmpRes_statusBlparasite}`)
          let tmpDetailBlparasite = []
          if(this.blParasiteMaterSelected == 'Found'){
           tmpDetailBlparasite = this.blParasiteDetailSelected
          } 
          
           

           this.isFullScreenLoading = true 
           const datTo = {  
                         "mode" : 1, // 0 == new insert , 1 == edit
                         "dat" :  {
                                    "idopd": this.opdSelected.idopd,
                                    "idlab" : this.dataToEdit_ManuallyLabAutomate['info'].idlab  ?  this.dataToEdit_ManuallyLabAutomate['info'].idlab : null  ,
                                    "bf" : this.lab_HIS_LIS_Mapping['bf'],
                                    "blood_gas": this.lab_HIS_LIS_Mapping['blood_gas'],
                                    "chemistry": this.lab_HIS_LIS_Mapping['chemistry'],
                                    "hm": this.lab_HIS_LIS_Mapping['hm'],
                                    "hormone": this.lab_HIS_LIS_Mapping['hormone'],
                                    "blmor_selected" : this.blMorSelected,
                                    //  "blparasite" : this.blParasiteParam.filter(dat=>dat.selectedValue!="")
                                    //                                     .map(dat=>{return { "id":dat.id,"selectedValue":dat.selectedValue} })
                                    "blparasite" : {
                                            "res_status": tmpRes_statusBlparasite,
                                            "detail": tmpDetailBlparasite
                                    },
                                    "ua" : UA_Tmp  ,
                                    "outlab" : this.lab_HIS_LIS_Mapping['outlab'],
                                    
                                    "commentnote" : ( (this.commentNoteModel !== null) && (this.commentNoteModel !== "") || (this.commentNoteModel?.length > 0)) ? Buffer.from(this.commentNoteModel).toString('base64') : null,
                                     
                                    "singni_phy":  ( (this.singni_phyModel !== null) && (this.singni_phyModel !== "")  && (this.singni_phyModel?.length > 0)) ? Buffer.from(this.singni_phyModel).toString('base64') : null,

                                    "tentative_dx" : ((this.tentative_dxModel !== null)  && (this.tentative_dxModel !== "")   || (this.tentative_dxModel?.length > 0)) ? Buffer.from(this.tentative_dxModel).toString('base64') : null,

                                    "test_desire" : ((this.test_desireModel !== null)  && (this.test_desireModel !== "")  || (this.test_desireModel?.length > 0)) ? Buffer.from(this.test_desireModel).toString('base64') : null, 

                                    "special_rq" : ((this.special_rqModel !== null) && (this.special_rqModel !== "")   || (this.special_rqModel?.length > 0)) ? Buffer.from(this.special_rqModel).toString('base64') : null, 
                                  
                                    "diagnosisNote": ((this.diagnosisNoteModel !== null) && (this.diagnosisNoteModel !== "")   || (this.diagnosisNoteModel?.length > 0)) ? Buffer.from(this.diagnosisNoteModel).toString('base64') : null, 
                                    "resultRemark": ((this.resultRemarkModel !== null) && (this.resultRemarkModel !== "")   || (this.resultRemarkModel?.length > 0)) ? Buffer.from(this.resultRemarkModel).toString('base64') : null, 
                                    
                                    
                                    "idclini"  :  this.userSelected    
                                  }
                         }
                        // console.log(JSON.stringify(datTo))
                        axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token})}`
                        axios.post(`${getBaseURLforBackEnd()}/api/addorupdate_maunuallabautomate`, datTo , getConfigAxios())
                             .then(()=>{
                               this.closeWithChangeData() 
                               this.isFullScreenLoading = false
                             })
                             .catch((err)=>{
                                    this.$buefy.toast.open({
                                    duration: 1000,
                                    message: `${err.data}`,
                                    position: 'is-bottom',
                                    type: 'is-success'
                                })
                                this.isFullScreenLoading = false
                            })
              

        //    console.log(JSON.stringify(datTo))

        //    const jsonString = JSON.stringify(datTo);
        //    const payloadSizeInBytes = new TextEncoder().encode(jsonString).length;

        //    console.log('Payload size in bytes:', payloadSizeInBytes);
           







        },
        closeSearchOPDWithChange(payload){
            // console.log(payload)
            this.setOpdSelected(
                   {
                    "address": payload.address  ,
                    "age": payload.age ,
                    "birth": payload.birth ,
                    "breed": payload.breed ,
                    "date_rec": payload.date_rec ,
                    "idopd": payload.idopd ,
                    "idown": payload.idown ,
                    "name": payload.name ,
                    "owner_name": payload.owner_name ,
                    "phone_mobile": payload.phone_mobile ,
                    "sex": payload.sex ,
                    "species": payload.species ,
                    "species_id": payload.species_id ,
                    "visit_active":payload.visit_active  ,
                 } 
            )



            // 
            this.$buefy.toast.open({
                    duration: 2500,
                    message: ` Change OPD to  <b>${payload.idopd}</b>  <i>${payload.name}</i>`,
                    position: 'is-bottom',
                    type: 'is-info'
            })




        },
       changeOPD(){
          this.modeSearchOPD =  1
          this.$refs.SearchOPD.isComponentModalActive = true
       },
       
        
       close(){
        this.$emit('close')
       },
       closeWithChangeData(){
        this.$emit('closeWithChangeData')
       },
       closeWithChangeOPDNo(){
        this.$emit('closeWithChangeOPDNo')
       },



     async  reloadBlankTemplate(){
          
              if(this.modeManuallyLabAutomate==0){
                  this.setOpdSelected( BLANK_OPD_FOR_MANUAL_LAB_AUTOMATE )
              }
           

             

            await  this.fetchLab_his_lis_mapping()
                .then(()=>{
                    this.valueProgress = 25
                    this.msgProgress = "template has loaded"
                } )
            // await new Promise(resolve => setTimeout(resolve, 10)); 



            await  this.fetchBlMor()
                .then(()=>{ 
                     this.valueProgress = 50
                     this.msgProgress = "Blood Mor has loaded"
                     })
            // await new Promise(resolve => setTimeout(resolve, 10)); 

            await  this.fetchBlParasite()
                 .then(()=> {
                   this.valueProgress = 75
                   this.msgProgress = "Blood Parasite has loaded"
                    })
            // await new Promise(resolve => setTimeout(resolve, 10)); 


            await this.fetchUAParams()
                 .then(()=> {
                    this.valueProgress = 100
                    this.msgProgress = "UA has loaded"
                     })


            
           this.commentNoteModel = ""
           this.singni_phyModel = ""
           this.tentative_dxModel = ""
           this.test_desireModel = ""
           this.special_rqModel = ""





            

          //  await new Promise(resolve => setTimeout(resolve, 10));


          //  this.isFullScreenLoading = false
          //  this.showProgress = false
           this.activeTab = 0

        //    if(this.arrDVM_Model.length==0){
        //       this.fetchArrDVM()
        //    }
           if(this.arrUsers_Model.length==0){
              await this.fetchArrUsers()
           }
            
         
        },
     async  fillOldData(){

            // fill data into state
            for(let i =0;i<= this.dataToEdit_ManuallyLabAutomate['hm'].length-1;i++){
               const tmp = this.lab_HIS_LIS_Mapping['hm'].find(dat=>dat.field_name == this.dataToEdit_ManuallyLabAutomate['hm'][i].field_name )
               if(tmp){
                tmp.val = this.dataToEdit_ManuallyLabAutomate['hm'][i].val
                tmp.unit = this.dataToEdit_ManuallyLabAutomate['hm'][i].unit
                tmp.ref = this.dataToEdit_ManuallyLabAutomate['hm'][i].ref
                tmp.flag = this.dataToEdit_ManuallyLabAutomate['hm'][i].flag
                tmp.machine_id = this.dataToEdit_ManuallyLabAutomate['hm'][i].machine_id
               }
            }
             

            for(let i =0;i<= this.dataToEdit_ManuallyLabAutomate['chemistry'].length-1;i++){
               const tmp = this.lab_HIS_LIS_Mapping['chemistry'].find(dat=>dat.field_name == this.dataToEdit_ManuallyLabAutomate['chemistry'][i].field_name )
               if(tmp){
                tmp.val = this.dataToEdit_ManuallyLabAutomate['chemistry'][i].val
                tmp.ref = this.dataToEdit_ManuallyLabAutomate['chemistry'][i].ref
                tmp.unit = this.dataToEdit_ManuallyLabAutomate['chemistry'][i].unit
                tmp.flag = this.dataToEdit_ManuallyLabAutomate['chemistry'][i].flag
                tmp.machine_id = this.dataToEdit_ManuallyLabAutomate['chemistry'][i].machine_id
               }
            }


            for(let i =0;i<= this.dataToEdit_ManuallyLabAutomate['bf'].length-1;i++){
               const tmp = this.lab_HIS_LIS_Mapping['bf'].find(dat=>dat.field_name == this.dataToEdit_ManuallyLabAutomate['bf'][i].field_name )
               if(tmp){
                tmp.val = this.dataToEdit_ManuallyLabAutomate['bf'][i].val
                tmp.ref = this.dataToEdit_ManuallyLabAutomate['bf'][i].ref
                tmp.unit = this.dataToEdit_ManuallyLabAutomate['bf'][i].unit
                tmp.flag = this.dataToEdit_ManuallyLabAutomate['bf'][i].flag
                tmp.machine_id = this.dataToEdit_ManuallyLabAutomate['bf'][i].machine_id
               }
            }




            for(let i =0;i<= this.dataToEdit_ManuallyLabAutomate['hormone'].length-1;i++){
               const tmp = this.lab_HIS_LIS_Mapping['hormone'].find(dat=>dat.field_name == this.dataToEdit_ManuallyLabAutomate['hormone'][i].field_name )
               if(tmp){
                tmp.val = this.dataToEdit_ManuallyLabAutomate['hormone'][i].val
                tmp.ref = this.dataToEdit_ManuallyLabAutomate['hormone'][i].ref
                tmp.unit = this.dataToEdit_ManuallyLabAutomate['hormone'][i].unit
                tmp.flag = this.dataToEdit_ManuallyLabAutomate['hormone'][i].flag
                tmp.machine_id = this.dataToEdit_ManuallyLabAutomate['hormone'][i].machine_id
               }
            }


            for(let i =0;i<= this.dataToEdit_ManuallyLabAutomate['blood_gas'].length-1;i++){
               const tmp = this.lab_HIS_LIS_Mapping['blood_gas'].find(dat=>dat.field_name == this.dataToEdit_ManuallyLabAutomate['blood_gas'][i].field_name )
               if(tmp){
                tmp.val = this.dataToEdit_ManuallyLabAutomate['blood_gas'][i].val
                tmp.ref = this.dataToEdit_ManuallyLabAutomate['blood_gas'][i].ref
                tmp.unit = this.dataToEdit_ManuallyLabAutomate['blood_gas'][i].unit
                tmp.flag = this.dataToEdit_ManuallyLabAutomate['blood_gas'][i].flag
                tmp.machine_id = this.dataToEdit_ManuallyLabAutomate['blood_gas'][i].machine_id
               }
            }


            for(let i =0;i<= this.dataToEdit_ManuallyLabAutomate['outlab'].length-1;i++){
               const tmp = this.lab_HIS_LIS_Mapping['outlab'].find(dat=>dat.field_name == this.dataToEdit_ManuallyLabAutomate['outlab'][i].field_name )
               if(tmp){
                tmp.val = this.dataToEdit_ManuallyLabAutomate['outlab'][i].val
                tmp.ref = this.dataToEdit_ManuallyLabAutomate['outlab'][i].ref
                tmp.unit = this.dataToEdit_ManuallyLabAutomate['outlab'][i].unit
                tmp.flag = this.dataToEdit_ManuallyLabAutomate['outlab'][i].flag
                tmp.machine_id = this.dataToEdit_ManuallyLabAutomate['outlab'][i].machine_id  
               }
            }
 

            if(this.dataToEdit_ManuallyLabAutomate['info'].comment_note != null || this.dataToEdit_ManuallyLabAutomate['info'].comment_note != ""  ){
                this.setCommentNote(this.dataToEdit_ManuallyLabAutomate['info'].comment_note) 
            }
            if(this.dataToEdit_ManuallyLabAutomate['info'].singni_phy != null ||  this.dataToEdit_ManuallyLabAutomate['info'].singni_phy != "" ){
                this.setSingni_phy(this.dataToEdit_ManuallyLabAutomate['info'].singni_phy) 
            }
            if(this.dataToEdit_ManuallyLabAutomate['info'].tentative_dx != null ||  this.dataToEdit_ManuallyLabAutomate['info'].tentative_dx != "" ){
                this.setTentative_dx(this.dataToEdit_ManuallyLabAutomate['info'].tentative_dx) 
            }
            if(this.dataToEdit_ManuallyLabAutomate['info'].test_desire != null ||  this.dataToEdit_ManuallyLabAutomate['info'].test_desire != "" ){
                this.setTest_desire(this.dataToEdit_ManuallyLabAutomate['info'].test_desire) 
            }
            if(this.dataToEdit_ManuallyLabAutomate['info'].special_rq != null ||  this.dataToEdit_ManuallyLabAutomate['info'].special_rq != "" ){
                this.setSpecial_rq(this.dataToEdit_ManuallyLabAutomate['info'].special_rq) 
            }

            if(this.dataToEdit_ManuallyLabAutomate['info'].diagnosis_note != null ||  this.dataToEdit_ManuallyLabAutomate['info'].diagnosis_note != "" ){
                this.setDiagnosisNote(this.dataToEdit_ManuallyLabAutomate['info'].diagnosis_note) 
            }

            if(this.dataToEdit_ManuallyLabAutomate['info'].result_remark != null ||  this.dataToEdit_ManuallyLabAutomate['info'].result_remark != "" ){
                this.setResultRemark(this.dataToEdit_ManuallyLabAutomate['info'].result_remark) 
            }

           

            //    blood mor
             this.blMorSelected.length = 0
             for(let i =0;i<=  this.dataToEdit_ManuallyLabAutomate['blmor'].length-1;i++){
               const tmp = this.blMor.find(dat=>dat.id ==  this.dataToEdit_ManuallyLabAutomate['blmor'][i].idblood_mor_name )
               if(tmp){
                 this.blMorSelected.push(tmp)
               }
            }
           
     




            // bl parasite
            this.setBlParasiteMaterSelected('') // reset
            this.setBlParasiteDetailSelected([]) // reset pass by empty array
            if( this.dataToEdit_ManuallyLabAutomate['blparasite_v3'] != null ){
               // Found  / Not Found
               this.setBlParasiteMaterSelected(this.dataToEdit_ManuallyLabAutomate['blparasite_v3'].res_status)
               if(this.dataToEdit_ManuallyLabAutomate['blparasite_v3'].res_status == 'Found'){
                   // detail
                   this.dataToEdit_ManuallyLabAutomate['blparasite_v3'].detail.forEach(dat => {
                         const blParasiteData = this.blParasiteParam.find(element => element.id === dat.bl_parasite_id)
                         blParasiteData.amount = dat.amount
                         blParasiteData.unit = dat.unit
                         blParasiteData.remark = dat.remark
                         this.blParasiteDetailSelected.push(blParasiteData)
                   }) 
               } 
            }

            // this.dataToEdit_ManuallyLabAutomate['blparasite_v2'].forEach(dat => {
            //     const blParasiteData = this.blParasiteParam.find(element => element.id === dat.bl_parasite_id)
            //     if (blParasiteData && blParasiteData.result_dat_aval.id.includes(dat.bl_parasite_val)) {
            //            blParasiteData.selectedValue = dat.bl_parasite_val
            //     }
            // });


 


            // UA 2
            //  
            this.UAParams.ur_ph = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "ur_ph") || {}).val || "";

            this.UAParams.ur_creatinine = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "ur_creatinine") || {}).val || "";
            const tmp_ur_creatinine = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "ur_creatinine");
            this.UAParams.ur_creatinine_remark = tmp_ur_creatinine?.remark ?? ""; 


            this.UAParams.ur_protein = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "ur_protein_amount") || {}).val || "";
            const tmp_ur_protein = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "ur_protein_amount");
            this.UAParams.ur_protein_remark = tmp_ur_protein?.remark ?? ""; 




            this.UAParams.ur_cortisol = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "ur_cortisol") || {}).val || "";
            const tmp_ur_cortisol = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "ur_cortisol");
            this.UAParams.ur_cortisol_remark = tmp_ur_cortisol?.remark ?? ""; 



            this.UAParams.ur_sp_gr = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "ur_sp_gr") || {}).val || "";
            
            
            
            this.UAParams.uccr = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "uccr") || {}).val || "";
            const tmp_uccr = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "uccr");
            this.UAParams.uccr_remark = tmp_uccr?.remark ?? ""; 
            // const tmp_uccr = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "uccr")
            // if(tmp_uccr){
            //     if(tmp_uccr.remark != null){
            //          this.UAParams.uccr_remark = tmp_uccr.remark
            //     }else{
            //          this.UAParams.uccr_remark = ""
            //     }
            // }
             
            

           
         
          
                                                                            
            this.UAParams.upcr = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "upcr") || {}).val || "";
            const tmp_upcr = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "upcr");
            this.UAParams.upcr_remark = tmp_upcr?.remark ?? "";     



              



            


            //colection_tech
            this.UAParams.colection_tech_id = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "colection_tech") || {}).val || "";
            this.UAParams.colection_tech_val = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "colection_tech") || {}).val_str || "";
            //color
            this.UAParams.color_id = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "color") || {}).val || "";
            this.UAParams.color_val = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "color") || {}).val_str || "";
            //Transparent
            this.UAParams.trans_id = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "trans") || {}).val || "";
            this.UAParams.trans_val = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "trans") || {}).val_str || "";
            //rbc
            this.UAParams.rbc = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "rbc") || {}).val ||  null;
            //wbc
            this.UAParams.wbc = (this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "wbc") || {}).val ||  null;
            //nirite
            const niriteData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "nirite");
            this.UAParams.nirite = niriteData?.val ?? null;
            this.UAParams.nirite_pos = (this.UAParams.nirite === 2) ? niriteData?.val_pos ?? null : null;
            //urobilinogen
            const urobilinogenData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "urobilinogen");
            this.UAParams.urobilinogen = urobilinogenData?.val ?? null;
            this.UAParams.urobilinogen_pos = (this.UAParams.urobilinogen === 2) ? urobilinogenData?.val_pos ?? null : null;
            //protein
            const proteinData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "protein");
            this.UAParams.protein = proteinData?.val ?? null;
            this.UAParams.protein_pos = (this.UAParams.protein === 2) ? proteinData?.val_pos ?? null : null;
            //blood
            const bloodData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "blood");
            this.UAParams.blood = bloodData?.val ?? null;
            this.UAParams.blood_pos = (this.UAParams.blood === 2) ? bloodData?.val_pos ?? null : null;
            //ketone
            const ketoneData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "ketone");
            this.UAParams.ketone = ketoneData?.val ?? null;
            this.UAParams.ketone_pos = (this.UAParams.ketone === 2) ? ketoneData?.val_pos ?? null : null;
            //bilirubin
            const bilirubinData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "bilirubin");
            this.UAParams.bilirubin = bilirubinData?.val ?? null;
            this.UAParams.bilirubin_pos = (this.UAParams.bilirubin === 2) ? bilirubinData?.val_pos ?? null : null;
            //glucose
            const glucoseData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "glucose");
            this.UAParams.glucose = glucoseData?.val ?? null;
            this.UAParams.glucose_pos = (this.UAParams.glucose === 2) ? glucoseData?.val_pos ?? null : null;
            //fat_drp
            const fat_drpData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "fat_drp");
            this.UAParams.fat_drp = fat_drpData?.val ?? null;
            this.UAParams.fat_drp_pos = (this.UAParams.fat_drp === 2) ? fat_drpData?.val_pos ?? null : null;
            //bact
            const bactData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "bact");
            this.UAParams.bact = bactData?.val ?? null;
            this.UAParams.bact_pos = (this.UAParams.bact === 2) ? bactData?.val_pos ?? null : null;
            //leu
            const leuData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "leu");
            this.UAParams.leu = leuData?.val ?? null;
            this.UAParams.leu_pos = (this.UAParams.leu === 2) ? leuData?.val_pos ?? null : null;
            //sprem
            const spremData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "sperm");
            this.UAParams.sprem = spremData?.val ?? null;
            this.UAParams.sprem_pos = (this.UAParams.sprem === 2) ? spremData?.val_pos ?? null : null;
            // const spermData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "sperm");
            // this.UAParams.sperm = spremData?.val ?? null;
            // this.UAParams.sprem_pos = (this.UAParams.sprem === 2) ? spremData?.val_pos ?? null : null;
            //FUNGI
            const fungiData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "fungi");
            this.UAParams.fungi = fungiData?.val ?? null;
            this.UAParams.fungi_pos = (this.UAParams.fungi === 2) ? fungiData?.val_pos ?? null : null; 
            //YEAST
            const yeastData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "yeast");
            this.UAParams.yeast = yeastData?.val ?? null;
            this.UAParams.yeast_pos = (this.UAParams.yeast === 2) ? yeastData?.val_pos ?? null : null; 


           
            // ur_casts
            const ur_castsData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "ur_casts");
            this.UAParams.cast_np = ur_castsData?.val;
            ur_castsData?.val_pos_arr.forEach(pos => {
            const tmp = this.UAParams.cast_pos_mst.find(dat => dat.id === pos.cast_id);
            if (tmp) tmp.val = pos.cast_pos_id;
            })



            // ur_cystals
            const ur_cystalsData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "ur_cystals");
            this.UAParams.cystal_np = ur_cystalsData?.val;
            ur_cystalsData?.val_pos_arr.forEach(pos => {
            const tmp = this.UAParams.cystal_pos_mst.find(dat => dat.id === pos.cystal_id);
            if (tmp) tmp.val = pos.cystal_pos_id;
            });


            // ur_epith
            const ur_epithData = this.dataToEdit_ManuallyLabAutomate['ua_v2'].find(dat => dat.id === "ur_epith");
            this.UAParams.epith_np  = ur_epithData?.val;
            ur_epithData?.val_pos_arr.forEach(pos => {
            const tmp = this.UAParams.epith_pos_mst.find(dat => dat.id === pos.epith_id);
            if (tmp) tmp.val = pos.epith_pos_id;
            });





           
            



            
 
            this.setOpdSelected(
                                {
                                    "address": this.dataToEdit_ManuallyLabAutomate['info'].address  ,
                                    "age": this.dataToEdit_ManuallyLabAutomate['info'].age ,
                                    "birth": this.dataToEdit_ManuallyLabAutomate['info'].birth  ,
                                    "breed":  this.dataToEdit_ManuallyLabAutomate['info'].breed,
                                    "date_rec": this.dataToEdit_ManuallyLabAutomate['info'].date_rec ,
                                    "idopd":  this.dataToEdit_ManuallyLabAutomate['info'].idopd ,
                                    "idown": this.dataToEdit_ManuallyLabAutomate['info'].idown ,
                                    "name": this.dataToEdit_ManuallyLabAutomate['info'].name,
                                    "owner_name":  this.dataToEdit_ManuallyLabAutomate['info'].owner_name,
                                    "phone_mobile": this.dataToEdit_ManuallyLabAutomate['info'].phone_mobile,
                                    "sex":  this.dataToEdit_ManuallyLabAutomate['info'].sex,
                                    "species": this.dataToEdit_ManuallyLabAutomate['info'].species ,
                                    "species_id":  this.dataToEdit_ManuallyLabAutomate['info'].species_id ,
                                    "visit_active": this.dataToEdit_ManuallyLabAutomate['info'].visit_active 
                                } 
            )

            // check user avaliable
            const tmpUsersAval = this.arrUsers_Model.find(dat=>dat.iduser ==  this.dataToEdit_ManuallyLabAutomate['info'].req_by_id )
            // console.log("tmpUsersAval-->",tmpUsersAval)
            if(tmpUsersAval){
               this.setUserSelected( this.dataToEdit_ManuallyLabAutomate['info'].req_by_id)
               this.set_userAutocomplete(this.dataToEdit_ManuallyLabAutomate['info'].req_by) 
            }else{
               this.setUserSelected(null)
               this.set_userAutocomplete( '' )  
            }

            // image
            // console.log(this.dataToEdit_ManuallyLabAutomate['images']) 
            this.setCBCImages(this.dataToEdit_ManuallyLabAutomate['images'])



     }   
    },
    data(){
        return{
            isFormReady: false,
            formLoadError: '',
            activeTab : 0, 
            isShowInfo : false,
            modeSearchOPD : 1,

            valueProgress : 0,
            isFullScreenLoading : false,
            msgProgress : "",
            showProgress: false,
        }
    },
    watch:{
      isComponentModalActive:{
        immediate: true,
        handler:async  function(val){
             if(val){
                await this.initializeForm()

             }
        }
      }
    }
}
</script>




<style scoped>
 .custom-modal-card-head1 {
  height: 50px;  
 
}  
  .level-scroll {
      overflow-x: auto;
      white-space: nowrap;
    }

    .level-item {
      margin-right: 10px; /* Adjust as needed */
      white-space: normal; /* Reset white-space for the buttons */
    } 


</style>
